import { PUBLIC_PRICING_PATH } from "@/lib/platform/pricing-destination";

/** Guest canonical pricing href — resolved per auth via `useMarketingNavLinks` / `PricingLink`. */
export const MARKETING_NAV_LINKS = [
  { name: "About", link: "/about" },
  { name: "Pricing", link: PUBLIC_PRICING_PATH },
  { name: "Contact", link: "/contact" },
] as const;

export const MARKETING_FOOTER_LINKS = [
  { label: "Pricing", href: PUBLIC_PRICING_PATH },
  { label: "About", href: "/about" },
  { label: "Contact us", href: "/contact" },
  { label: "Privacy Policy", href: "/privacy" },
  { label: "Terms of Service", href: "/terms" },
] as const;

export const PUBLIC_MARKETING_PATHS = new Set([
  "/",
  "/about",
  PUBLIC_PRICING_PATH,
  "/contact",
  "/privacy",
  "/terms",
]);

export function isPublicMarketingPath(path: string) {
  return PUBLIC_MARKETING_PATHS.has(path);
}
